"use client";
import { sendSalesforceInteraction } from "@/helpers/cdnSdk";
import { addDataLayer } from "@/helpers/dataLayer";
import { getUTMParameter } from "@/helpers/getUTMParameters";
import { stripHtmlTags } from "@/helpers/useCommonFunctions";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { Box } from "@dxp-feed/ui/Box";
import Link from "@/components/Link";
import React from "react";
import Image from "next/image";

export default function PrimaryList({ headerData }: any) {
  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);
  return (
    <>
      {headerData?.primaryList?.map((listItem: any, index: number) => (
        <Link
          href={listItem?.headingLink ? listItem?.headingLink : "#"}
          key={listItem.heading + index}
          target={listItem.primaryTarget}
          rel={listItem.primaryTarget === "_blank" ? "noopener" : undefined}
          aria-label={`click to ${listItem.heading}`}
          prefetch={false}
          onClick={() => {
            addDataLayer({
              event: "nav_header",
              click_text: stripHtmlTags(listItem?.heading),
              click_url: listItem?.headingLink
                ? listItem?.headingLink
                : "/flyer",
              page_title: document.title,
            });
            sendSalesforceInteraction({
              name: "nav_click",
              banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
              clickText: stripHtmlTags(listItem?.heading),
              clickUrl: listItem?.headingLink
                ? listItem?.headingLink
                : "/flyer",
              screenClass: window?.location?.href,
              screenName: document.title,
              isAnonymous: Uid ? 0 : 1,
              gigyaUid: Uid,
              utmSource: getUTMParameter("utm_source"),
              utmMedium: getUTMParameter("utm_medium"),
              utmCampaign: getUTMParameter("utm_campaign"),
            });
          }}
          className="text-[14px] font-normal leading-normal hover:underline px-[4px] py-[10px]"
        >
          {listItem.heading}
        </Link>
      ))}

      <Link
        className="py-1"
        href={headerData?.voilalink}
        target="primaryTarget"
        aria-label={"Voila Image"}
        rel={headerData?.voilalink.primaryTarget === "_blank" ? "noopener" : undefined}
        prefetch={false}
        onClick={() => {
          addDataLayer({
            event: "nav_header",
            click_text: "Voila",
            click_url: headerData?.voilalink,
            page_title: document.title,
          });
          sendSalesforceInteraction({
            name: "nav_click",
            banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
            clickText: "Voila",
            clickUrl: headerData?.voilalink,
            screenClass: window?.location?.href,
            screenName: document.title,
            isAnonymous: Uid ? 0 : 1,
            gigyaUid: Uid,
            utmSource: getUTMParameter("utm_source"),
            utmMedium: getUTMParameter("utm_medium"),
            utmCampaign: getUTMParameter("utm_campaign"),
          });
        }}
      >
        <Image
          src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${headerData?.voilaImage || ""}`}
          height={40}
          width={214}
          alt="Voila"
          className="lg:max-w-max max-w-full h-9"
          fetchPriority="high"
          loading="eager"
        />
      </Link>
    </>
  );
}
